import { Icon, type IconTone } from './Icon';

/**
 * Сота — знак Мезы: заглушка состояния, пустой кадр, приглашение загрузить
 * фото. Была нарисована трижды своим `<svg>`. `plus` — то же приглашение с
 * крестом.
 */
export function HexIcon({
  size,
  plus = false,
  tone,
}: {
  size?: number;
  plus?: boolean;
  tone?: IconTone;
}) {
  return (
    <Icon size={size} box={[20, 22]} strokeWidth={1} tone={tone}>
      <path d="M10 1 L18.7 6 V16 L10 21 L1.3 16 V6 Z" />
      {/* Крест короче на полштриха с каждого конца: концы у набора
          скруглённые, видимая длина та же — 6.8. */}
      {plus ? <path d="M10 8.1 v5.8 M7.1 11 h5.8" /> : null}
    </Icon>
  );
}
